import { flowTypes, pageConfig } from '@/common/service/page-config';
import { translation } from '@/plugins/i18n';
import { getOnlinePlanName } from '@/common/product';

const existingPlanCode = '200001'; // when the customer have current edit plan, redirect url is edit flow

export const getFlowRedirectMessage = ({ currentEditPlan }) => {
  const flowType = pageConfig?.type;
  const redirectCode = pageConfig?.redirectCode;
  const enableRedirectMessage = pageConfig?.enableRedirectMessage;

  // when the customer have current edit plan, redirect url is edit flow
  if (flowType === flowTypes.edit && redirectCode === existingPlanCode && currentEditPlan && enableRedirectMessage) {
    const planName = getOnlinePlanName(currentEditPlan);
    return planName ? translation('billing.error.existing_plan_msg', [window.SB?.user?.email, planName]) : '';
  }

  return '';
};
